import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.orderType = ''
      this.orderFrom = ''
      this.sportsProjectCode = ''
      this.payType = ''
      this.range = []
      this.searchType = 'venue'
    }
  }
}
export default searchFrom
